import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import baseStyles from './styles/baseStyles';
import Colours from '../tokens/colours';
import FontSizes from '../tokens/fontSizes';
const iconFill = (disabled = false, hover, variant) => {
    if ((variant === 'primary') ||
        (disabled && variant === 'secondary') ||
        (hover && variant === 'primary')) {
        return Colours.white;
    }
    if (disabled && variant === 'tertiary') {
        return Colours.quinternary;
    }
    return Colours.primary;
};
const buttonStyle = (colour, border, fontColour, hoverColour) => ({
    backgroundColor: colour,
    border,
    color: fontColour,
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: hoverColour,
    },
});
const buttonStyledisabled = (colour, fontColour) => ({
    backgroundColor: colour,
    color: fontColour,
    '&:hover': {
        cursor: 'default',
        backgroundColor: colour,
    },
});
export const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        lineSpacing: '2.4rem',
        border: 'none',
        height: '4.1rem',
        width: '10.8rem',
        fontSize: FontSizes.Regular,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    primary: {
        ...buttonStyle(Colours.primary, 'none', Colours.white, Colours.secondary),
    },
    primarydisabled: {
        ...buttonStyledisabled(Colours.tertiary, Colours.white),
    },
    secondary: {
        ...buttonStyle(Colours.quarternary, 'none', Colours.primary, Colours.quinternary),
    },
    secondarydisabled: {
        ...buttonStyledisabled(Colours.quarternary, Colours.white),
    },
    tertiary: {
        ...buttonStyle(Colours.white, `1px solid ${Colours.quinternary}`, Colours.primary, Colours.quarternary),
    },
    tertiarydisabled: {
        ...buttonStyledisabled(Colours.white, Colours.quinternary),
    },
    icon: {
        marginRight: 8,
    },
});
const ActionButton = ({ children, className, onClick, type = 'button', variant = 'primary', disabled = false, Icon, }) => {
    const styles = getStyles();
    const [hover, setHover] = useState(false);
    return (React.createElement("button", { onMouseEnter: () => setHover(prev => !prev), onMouseLeave: () => setHover(prev => !prev), type: type, className: classNames(styles.root, styles[variant], {
            [styles[`${variant}disabled`]]: disabled,
        }, className), onClick: onClick },
        Icon && React.createElement(Icon, { width: '20', height: '20', fill: iconFill(disabled, hover, variant), className: classNames(styles.icon) }),
        children));
};
export default ActionButton;
//# sourceMappingURL=ActionButton.js.map